import { createFileRoute } from '@tanstack/react-router'
import { FeatureGate } from '@/components/feature-locked'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/vto'
)({
  component: VtoLayout,
})

function VtoLayout() {
  return <FeatureGate feature='image' />
}
